"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EG = void 0;
exports.EG = {
    numericCode: '818',
    alpha2Code: 'EG',
    alpha3Code: 'EGY',
    englishName: {
        short: 'Egypt',
        full: 'the Arab Republic of Egypt',
    },
    names: {
        full: {
            en: 'the Arab Republic of Egypt',
            fr: "la République arabe d'Égypte",
            ar: 'Mişr',
        },
        short: {
            en: 'Egypt',
            fr: "Égypte (l')",
            ar: 'Mişr',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'ar',
            languageAlpha3Code: 'ara',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
    ],
    subdivisions: {
        'EG-ALX': {
            numericCode: '818',
            code: 'EG-ALX',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Iskandarīyah',
            },
        },
        'EG-ASN': {
            numericCode: '818',
            code: 'EG-ASN',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Aswān',
            },
        },
        'EG-AST': {
            numericCode: '818',
            code: 'EG-AST',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Asyūţ',
            },
        },
        'EG-BA': {
            numericCode: '818',
            code: 'EG-BA',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Baḩr al Aḩmar',
            },
        },
        'EG-BH': {
            numericCode: '818',
            code: 'EG-BH',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Buḩayrah',
            },
        },
        'EG-BNS': {
            numericCode: '818',
            code: 'EG-BNS',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Banī Suwayf',
            },
        },
        'EG-C': {
            numericCode: '818',
            code: 'EG-C',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Qāhirah',
            },
        },
        'EG-DK': {
            numericCode: '818',
            code: 'EG-DK',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Ad Daqahlīyah',
            },
        },
        'EG-DT': {
            numericCode: '818',
            code: 'EG-DT',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Dumyāţ',
            },
        },
        'EG-FYM': {
            numericCode: '818',
            code: 'EG-FYM',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Fayyūm',
            },
        },
        'EG-GH': {
            numericCode: '818',
            code: 'EG-GH',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Gharbīyah',
            },
        },
        'EG-GZ': {
            numericCode: '818',
            code: 'EG-GZ',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Jīzah',
            },
        },
        'EG-IS': {
            numericCode: '818',
            code: 'EG-IS',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: "Al Ismā'īlīyah",
            },
        },
        'EG-JS': {
            numericCode: '818',
            code: 'EG-JS',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: "Janūb Sīnā'",
            },
        },
        'EG-KB': {
            numericCode: '818',
            code: 'EG-KB',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Qalyūbīyah',
            },
        },
        'EG-KFS': {
            numericCode: '818',
            code: 'EG-KFS',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Kafr ash Shaykh',
            },
        },
        'EG-KN': {
            numericCode: '818',
            code: 'EG-KN',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Qinā',
            },
        },
        'EG-LX': {
            numericCode: '818',
            code: 'EG-LX',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Uqşur',
            },
        },
        'EG-MN': {
            numericCode: '818',
            code: 'EG-MN',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Minyā',
            },
        },
        'EG-MNF': {
            numericCode: '818',
            code: 'EG-MNF',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Minūfīyah',
            },
        },
        'EG-MT': {
            numericCode: '818',
            code: 'EG-MT',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Maţrūḩ',
            },
        },
        'EG-PTS': {
            numericCode: '818',
            code: 'EG-PTS',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Būr Sa‘īd',
            },
        },
        'EG-SHG': {
            numericCode: '818',
            code: 'EG-SHG',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Sūhāj',
            },
        },
        'EG-SHR': {
            numericCode: '818',
            code: 'EG-SHR',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Ash Sharqīyah',
            },
        },
        'EG-SIN': {
            numericCode: '818',
            code: 'EG-SIN',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: "Shamāl Sīnā'",
            },
        },
        'EG-SUZ': {
            numericCode: '818',
            code: 'EG-SUZ',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'As Suways',
            },
        },
        'EG-WAD': {
            numericCode: '818',
            code: 'EG-WAD',
            category: {
                id: '316',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Wādī al Jadīd',
            },
        },
    },
    cities: [
        {
            name: 'Ziftá',
            subdivision: 'Muḩāfaz̧at al Gharbīyah',
        },
        {
            name: 'Toukh',
            subdivision: 'Muḩāfaz̧at al Qalyūbīyah',
        },
        {
            name: 'Tanda',
            subdivision: 'Muḩāfaz̧at al Gharbīyah',
        },
        {
            name: 'Ţāmiyah',
            subdivision: 'Muḩāfaz̧at al Fayyūm',
        },
        {
            name: 'Ţalkhā',
            subdivision: 'Muḩāfaz̧at ad Daqahlīyah',
        },
        {
            name: 'Talā',
            subdivision: 'Muḩāfaz̧at al Minūfīyah',
        },
        {
            name: 'Ţahţā',
            subdivision: 'Sūhāj',
        },
        {
            name: 'Sumusţā as Sulţānī',
            subdivision: 'Muḩāfaz̧at Banī Suwayf',
        },
        {
            name: 'Sohag',
            subdivision: 'Sūhāj',
        },
        {
            name: 'Sīdī Sālim',
            subdivision: 'Kafr ash Shaykh',
        },
        {
            name: 'Shirbīn',
            subdivision: 'Muḩāfaz̧at ad Daqahlīyah',
        },
        {
            name: 'Shibīn al Qanāţir',
            subdivision: 'Muḩāfaz̧at al Qalyūbīyah',
        },
        {
            name: 'Shibīn al Kawm',
            subdivision: 'Muḩāfaz̧at al Minūfīyah',
        },
        {
            name: 'Samannūd',
            subdivision: 'Muḩāfaz̧at al Gharbīyah',
        },
        {
            name: 'Samālūţ',
            subdivision: 'Al Minyā',
        },
        {
            name: 'Rosetta',
            subdivision: 'Al Buḩayrah',
        },
        {
            name: 'Ras Gharib',
            subdivision: 'Red Sea',
        },
        {
            name: 'Quwaysinā',
            subdivision: 'Muḩāfaz̧at al Minūfīyah',
        },
        {
            name: 'Quţūr',
            subdivision: 'Muḩāfaz̧at al Gharbīyah',
        },
        {
            name: 'Kousa',
            subdivision: 'Qinā',
        },
        {
            name: 'Qinā',
            subdivision: 'Qinā',
        },
        {
            name: 'Qalyūb',
            subdivision: 'Muḩāfaz̧at al Qalyūbīyah',
        },
        {
            name: 'Naj‘ Ḩammādī',
            subdivision: 'Qinā',
        },
        {
            name: 'Minyat an Naşr',
            subdivision: 'Muḩāfaz̧at ad Daqahlīyah',
        },
        {
            name: 'Minūf',
            subdivision: 'Muḩāfaz̧at al Minūfīyah',
        },
        {
            name: 'Maţāy',
            subdivision: 'Al Minyā',
        },
        {
            name: 'Mashtūl as Sūq',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Mersa Matruh',
            subdivision: 'Muḩāfaz̧at Maţrūḩ',
        },
        {
            name: 'Manfalūţ',
            subdivision: 'Asyūţ',
        },
        {
            name: 'Mallawī',
            subdivision: 'Al Minyā',
        },
        {
            name: 'Madīnat Sittah Uktūbar',
            subdivision: 'Al Jīzah',
        },
        {
            name: 'Kawm Umbū',
            subdivision: 'Aswān',
        },
        {
            name: 'Kawm Ḩamādah',
            subdivision: 'Al Buḩayrah',
        },
        {
            name: 'Kafr Şaqr',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Kafr az Zayyāt',
            subdivision: 'Muḩāfaz̧at al Gharbīyah',
        },
        {
            name: 'Kafr ash Shaykh',
            subdivision: 'Kafr ash Shaykh',
        },
        {
            name: 'Kafr ad Dawwār',
            subdivision: 'Al Buḩayrah',
        },
        {
            name: 'Juhaynah',
            subdivision: 'Sūhāj',
        },
        {
            name: 'Jirjā',
            subdivision: 'Sūhāj',
        },
        {
            name: '‘Izbat al Burj',
            subdivision: 'Muḩāfaz̧at ad Daqahlīyah',
        },
        {
            name: 'Iţsā',
            subdivision: 'Muḩāfaz̧at al Fayyūm',
        },
        {
            name: 'Isnā',
            subdivision: 'Qinā',
        },
        {
            name: 'Idkū',
            subdivision: 'Al Buḩayrah',
        },
        {
            name: 'Idfū',
            subdivision: 'Aswān',
        },
        {
            name: 'Ibshawāy',
            subdivision: 'Muḩāfaz̧at al Fayyūm',
        },
        {
            name: 'Ḩalwān',
            subdivision: 'Cairo Governorate',
        },
        {
            name: 'Hihyā',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Ḩawsh ‘Īsá',
            subdivision: 'Al Buḩayrah',
        },
        {
            name: 'Fuwwah',
            subdivision: 'Kafr ash Shaykh',
        },
        {
            name: 'Farshūţ',
            subdivision: 'Qinā',
        },
        {
            name: 'Fāraskūr',
            subdivision: 'Dumyāţ',
        },
        {
            name: 'Fāqūs',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Damietta',
            subdivision: 'Dumyāţ',
        },
        {
            name: 'Diyarb Najm',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Disūq',
            subdivision: 'Kafr ash Shaykh',
        },
        {
            name: 'Dishnā',
            subdivision: 'Qinā',
        },
        {
            name: 'Dikirnis',
            subdivision: 'Muḩāfaz̧at ad Daqahlīyah',
        },
        {
            name: 'Dayrūţ',
            subdivision: 'Asyūţ',
        },
        {
            name: 'Dayr Mawās',
            subdivision: 'Al Minyā',
        },
        {
            name: 'Damanhūr',
            subdivision: 'Al Buḩayrah',
        },
        {
            name: 'Būsh',
            subdivision: 'Muḩāfaz̧at Banī Suwayf',
        },
        {
            name: 'Port Said',
            subdivision: 'Muḩāfaz̧at Būr Sa‘īd',
        },
        {
            name: 'Būr Safājah',
            subdivision: 'Red Sea',
        },
        {
            name: 'Bilqās',
            subdivision: 'Muḩāfaz̧at ad Daqahlīyah',
        },
        {
            name: 'Bilbays',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Basyūn',
            subdivision: 'Muḩāfaz̧at al Gharbīyah',
        },
        {
            name: 'Banī Suwayf',
            subdivision: 'Muḩāfaz̧at Banī Suwayf',
        },
        {
            name: 'Banī Mazār',
            subdivision: 'Al Minyā',
        },
        {
            name: 'Banhā',
            subdivision: 'Muḩāfaz̧at al Qalyūbīyah',
        },
        {
            name: 'Zagazig',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Awsīm',
            subdivision: 'Al Jīzah',
        },
        {
            name: 'At Tall al Kabīr',
            subdivision: 'Al Ismā‘īlīyah',
        },
        {
            name: 'Asyūţ',
            subdivision: 'Asyūţ',
        },
        {
            name: 'Aswan',
            subdivision: 'Aswān',
        },
        {
            name: 'Suez',
            subdivision: 'As Suways',
        },
        {
            name: 'Aş Şaff',
            subdivision: 'Al Jīzah',
        },
        {
            name: 'Ash Shuhadā’',
            subdivision: 'Muḩāfaz̧at al Minūfīyah',
        },
        {
            name: 'Ashmūn',
            subdivision: 'Muḩāfaz̧at al Minūfīyah',
        },
        {
            name: 'Al Wāsiţah',
            subdivision: 'Muḩāfaz̧at al Fayyūm',
        },
        {
            name: 'Luxor',
            subdivision: 'Luxor',
        },
        {
            name: 'Al Qūşīyah',
            subdivision: 'Asyūţ',
        },
        {
            name: 'Al Quşayr',
            subdivision: 'Red Sea',
        },
        {
            name: 'Al Qurayn',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Al Qanāyāt',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Al Qanāţir al Khayrīyah',
            subdivision: 'Muḩāfaz̧at al Qalyūbīyah',
        },
        {
            name: 'Cairo',
            subdivision: 'Cairo Governorate',
        },
        {
            name: 'Al Minyā',
            subdivision: 'Al Minyā',
        },
        {
            name: 'Al Maţarīyah',
            subdivision: 'Muḩāfaz̧at ad Daqahlīyah',
        },
        {
            name: 'Al Manzilah',
            subdivision: 'Muḩāfaz̧at ad Daqahlīyah',
        },
        {
            name: 'Al Manşūrah',
            subdivision: 'Muḩāfaz̧at ad Daqahlīyah',
        },
        {
            name: 'Al Manshāh',
            subdivision: 'Sūhāj',
        },
        {
            name: 'Al Maḩallah al Kubrá',
            subdivision: 'Muḩāfaz̧at al Gharbīyah',
        },
        {
            name: 'Al Khārijah',
            subdivision: 'Muḩāfaz̧at al Wādī al Jadīd',
        },
        {
            name: 'Al Khānkah',
            subdivision: 'Muḩāfaz̧at al Qalyūbīyah',
        },
        {
            name: 'Al Jīzah',
            subdivision: 'Al Jīzah',
        },
        {
            name: 'Al Jamālīyah',
            subdivision: 'Muḩāfaz̧at ad Daqahlīyah',
        },
        {
            name: 'Ismailia',
            subdivision: 'Al Ismā‘īlīyah',
        },
        {
            name: 'Alexandria',
            subdivision: 'Alexandria',
        },
        {
            name: 'Al Ibrāhīmīyah',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Al Ḩawāmidīyah',
            subdivision: 'Al Jīzah',
        },
        {
            name: 'Al Ḩāmūl',
            subdivision: 'Kafr ash Shaykh',
        },
        {
            name: 'Hurghada',
            subdivision: 'Red Sea',
        },
        {
            name: 'Al Fayyūm',
            subdivision: 'Muḩāfaz̧at al Fayyūm',
        },
        {
            name: 'Al Fashn',
            subdivision: 'Muḩāfaz̧at Banī Suwayf',
        },
        {
            name: 'Al Bawīţī',
            subdivision: 'Al Jīzah',
        },
        {
            name: 'Al Balyanā',
            subdivision: 'Sūhāj',
        },
        {
            name: 'Al Bājūr',
            subdivision: 'Muḩāfaz̧at al Minūfīyah',
        },
        {
            name: 'Al Badārī',
            subdivision: 'Asyūţ',
        },
        {
            name: 'Al ‘Ayyāţ',
            subdivision: 'Al Jīzah',
        },
        {
            name: 'Arish',
            subdivision: 'Shamāl Sīnāʼ',
        },
        {
            name: 'Akhmīm',
            subdivision: 'Sūhāj',
        },
        {
            name: 'Ajā',
            subdivision: 'Muḩāfaz̧at ad Daqahlīyah',
        },
        {
            name: 'Ad Dilinjāt',
            subdivision: 'Al Buḩayrah',
        },
        {
            name: 'Abū Tīj',
            subdivision: 'Asyūţ',
        },
        {
            name: 'Abū Qurqāş',
            subdivision: 'Al Minyā',
        },
        {
            name: 'Abū Kabīr',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Abū al Maţāmīr',
            subdivision: 'Al Buḩayrah',
        },
        {
            name: 'Abnūb',
            subdivision: 'Asyūţ',
        },
        {
            name: 'Az Zarqā',
            subdivision: 'Dumyāţ',
        },
        {
            name: 'Ain Sukhna',
            subdivision: 'As Suways',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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